export const VideoPlayer = ({ src, className, onClick, isQuestionEmbed }) => {
  return (
    isQuestionEmbed ? (
      <iframe
        className={className}
        onClick={onClick}
        src={src}
        width="100%"
        title="video player"
      />
    ) : (
      <div 
        className={`${className} flex flex-col items-center justify-start`}
        onClick={onClick}
      >
        <iframe
          src={src}
          width="100%"
          title="video player"
          onClick={(e) => e.preventDefault()}
        />
        <p className="pt-1">Click here to select</p>
      </div>
    )
  );
};
